import React from 'react';
import { useNavigate } from 'react-router-dom';
import $ from "jquery";
import { useState } from 'react';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import PreLoginApi from '../../../components/Api/PreLoginApi';
import preLoginGetApi from '../../../components/Api/PreLoginGetApi';
import FooterContact from '../FooterContact';


const StepFour = () => {
    let navigate = useNavigate();
    const [data, setData] = useState({});
    

    const [input, setInput] = useState({});
    useEffect(()=>{
        const tokenParam = new URLSearchParams(window.location.search).get('token')?.toString().replaceAll(" ","+");
        if( tokenParam === null || tokenParam === undefined || tokenParam === "" ) {
            return navigate("/");
        }

        // Now Check by API call
        try {
            PreLoginApi("panel/company-registration-request/validateToken",JSON.stringify({token: tokenParam})).then((responseJSON) => {
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if( response["status"] === 0 ) {
                    toast.error("A problem occur. Please try again.");
                    return navigate("/");
                }
                
                let data = JSON.stringify(response["data"]);
                data = JSON.parse(data);

                if (data["code"] === 200) {
                    setData(data["data"]);

                    const step3 = JSON.parse(data["data"]?.step3);
                    if( step3?.account_number?.length > 0 ) {
                        return navigate("/company-registration-step-five?token="+tokenParam);
                    }

                    setInput({...input, token: tokenParam});
                    return;
                }


                // redirect to login page
                toast.error(data["messages"]);
                return navigate("/company-registration-step-three?token="+tokenParam);

            }).catch((error) => {
                toast.error(error);
            });
        }
        catch (err) {
            toast.error(err);
            console.log(err);
        }

    },[]);


    const handleSubmit = event => {
        event.preventDefault();

        // Now call API to store and proceed to next
        if(input.account_number?.length === 0 || input.bank?.length === 0 || input.branch?.length === 0) {
            toast.error("Please fill up all fields with * sign");
            return;
        }

        // Now Call API
        PreLoginApi("panel/company-registration-request/step3", JSON.stringify(input)).then((responseJSON) => {
            var response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if( response["status"] === 0 ) {
                toast.error("A problem occur. Please try again.");
                return;
            }
            
            let responseData = JSON.stringify(response["data"]);
            responseData = JSON.parse(responseData);

            if (responseData["code"] === 200) {
                toast.success(responseData["messages"] ?? "Information added successfully");
                return navigate("/company-registration-step-five?token=" + input.token);
            }

            toast.error(responseData["messages"]);
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        });
    }

    const [bank, setBank] = useState([]);
    useEffect(()=>{
        try {
            preLoginGetApi("api/v1/panel/company-registration-request/banks-pre-login",).then((responseJSON) => {
                
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if( response["status"] === 0 ) {
                    toast.error("A problem occur. Please try again.");
                }
                
                let data = JSON.stringify(response["data"]);
                data = JSON.parse(data);

                if (data["code"] === 200) {
                    setBank(data["data"]);
                    return;
                }


                // redirect to login page
                toast.error(data["messages"]);

                
            }).catch((error) => {
                toast.error(error);
            });
        }
        catch(err) {
            toast.error("A problem occur. Please try again.");
            console.log(err);
        }
    },[]);


    const [bankBranch, setBankBranch] = useState([]);
    const getBranchLists = (bank_id) => {
        PreLoginApi("panel/company-registration-request/branches-based-on-bank-pre-login",JSON.stringify({bank_id: bank_id})).then((responseJSON) => {
                
            var response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if( response["status"] === 0 ) {
                toast.error("A problem occur. Please try again.");
                return navigate("/");
            }
            
            let data = JSON.stringify(response["data"]);
            data = JSON.parse(data);

            if (data["code"] === 200) {
                setBankBranch(data["data"]);
                return;
            }
            
        }).catch((error) => {
            toast.error(error);
        });
    }

    const handleChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;

        if(name === "bank") {
            if(value?.length > 0) {
                getBranchLists(value);
            }
        }



        setInput({...input, [name] : value});
    }


    useEffect(()=>{
        $('.btn').css({ opacity: '0.6' });
        $('.btn').attr("disabled", true);
        
        if(input.account_number?.length > 0 && input.bank?.length > 0 && input.branch?.length > 0) {
            $('.btn').css({ opacity: '1' });
            $('.btn').attr("disabled", false);
        }

    },[input]);






    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className="flex h-full flex-wrap items-center justify-center lg:justify-center">


                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">

                            <div className="w-full bg-[#1882FF] rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
                                <div className="py-6 px-2 sm:py-10 sm:px-6">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="mb-6 font-semibold leading-8 text-white text-[25px] dark:text-white">
                                        ShareTrip Partner Registration
                                    </p>


                                    
                                    <form onSubmit={handleSubmit} method="POST">

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Account Name (Same as company name)</p>
                                        <div className='mb-2'>
                                            <input type="text" name="account_name" autoComplete='off' disabled={true} value={data.company_name ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Account Name (Same as company name)" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Account Number *</p>
                                        <div className='mb-2'>
                                            <input type="number" name="account_number" autoComplete='off' value={input.account_number ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Account Number" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Bank Name *</p>
                                        <div className='mb-2'>
                                            {bank.length > 0 && 
                                                <select name="bank" value={input.bank ?? ""} onChange={handleChange} className='bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed' required={true} >
                                                    <option value="" className='text-gray-300'>Select One</option>
                                                    {bank.map((data, index)=>
                                                        <option value={data.id} key={index} className='text-black'>{data.name}</option>
                                                    )}

                                                </select>
                                            }
                                        </div>


                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Bank Branch Name *</p>
                                        <div className='mb-2'>
                                            <select name="branch" value={input.branch ?? ""} onChange={handleChange} className='bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed' required={true} >
                                                <option value="" className='text-gray-300'>Select One</option>
                                                {bankBranch.map((data, index)=>
                                                    <option value={data.id} key={index} className='text-black'>{data.name}</option>
                                                )}

                                            </select>
                                        </div>


                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Bank Routing Number</p>
                                        <div className='mb-2'>
                                            <input type="text" name="routing_number" autoComplete='off' value={input.routing_number ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Bank Routing Number" />
                                        </div>
                                        

                                        
                                        <button id="submit_btn" disabled={true} className="btn mt-4 w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60 disabled:cursor-not-allowed">
                                            Next
                                        </button>


                                        {/* <p className='text-white text-sm text-right mr-1'>
                                            <span onClick={cancelProceed} className="cursor-pointer text-sm font-medium text-white text-right ml-1">
                                                Register Later ?
                                            </span>
                                        </p> */}

                                    </form>
                                    
                                </div>
                            </div>

                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepFour;